import React, { useEffect, useState } from 'react'
import './Header.css'
import axios from 'axios';

const instance = axios.create({
  withCredentials: true,
});

export default function Header() {
  const [userInfo, setUserInfo] = useState(null)

  useEffect(() => {
    try {
      instance.get("https://api.360ep.cn/api/user").then(res => {        
        setUserInfo(res.data.data)
      })
    } catch (error) {
      console.log(error)
    }
  }, [])

  return (
    <div className='header-div'>
      <ul>
        <li><a href="https://www.360ep.cn/">首页</a></li>
        <li><a href="https://yl.360ep.cn/">原料</a></li>
        <li><a href="https://gxl.360ep.cn/">改性料</a></li>
        <li><a href="https://zsl.360ep.cn/">再生料</a></li>
        <li><a href="https://info.360ep.cn/">资讯</a></li>
        <li><a href="https://info.360ep.cn/exhibit/list.php?flag=0">展会</a></li>
        <li><a href="https://info.360ep.cn/exhibit/list.php?flag=1">峰会</a></li>
        <li><a href="https://www.360ep.cn/sj/">时价</a></li>
        <li><a href="https://www.360ep.cn/pseries/">PE</a></li>
        <li><a href="https://sep.360ep.cn/">特种工程塑料</a></li>
      </ul>
      <ul>
        <li><a href="">微博</a></li>
        <li><a href="">微信</a></li>
        <li>
          {userInfo !== null ? (
            <>
              欢迎您<span className="f_red">{userInfo.Truename}</span>！
            </>
          ) : (
            <>
              <a href="https://www.360ep.cn/member/login.php">请登录</a> |{' '}
              <a href="https://www.360ep.cn/member/register.php">免费注册</a> |{' '}
              <a href="https://www.360ep.cn/member/send.php">忘记密码?</a>
            </>
          )}
        </li>
      </ul>
    </div>
  )
}
